import styled from 'styled-components';
import WabeImage from '../../backgrounds/bg-wabe.svg';
import {BREAKPOINT} from '../../../config';

export const MainContainer = styled.div`
    position: relative;
    height: 100%;
    background: url(${WabeImage}) repeat, radial-gradient(at center, #e7e7e7 0, #d5d5d5 100%);
    display: none;

    @media (min-width: ${BREAKPOINT}px) {
        display: block;
    }
`;
